<div class="asset-rate-card-component">

  <div class="row">
    <div class="col-lg-6 col-md-12">
      <asset-tier1 [title]="tier1AssetTitle" [maxYear]="15" [mark]="triggerMark" [formControl]="formControlTier1Asset"></asset-tier1>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="row">
    <div class="col-lg-6 col-md-12">
      <asset-tier2 [title]="tier2AssetTitle" [maxYear]="15" [mark]="triggerMark" [formControl]="formControlTier2Asset"></asset-tier2>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="row">
    <div class="col-lg-6 col-md-12">
      <asset-tier3 [title]="tier3AssetTitle" [mark]="triggerMark" [maxYear]="15" [formControl]="formControlTier3Asset"></asset-tier3>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="row">
    <div class="col-lg-6 col-md-12">
      <asset-tier4 [title]="tier4AssetTitle" [mark]="triggerMark" [formControl]="formControlTier4Asset"></asset-tier4>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="mat-h3 rate-card-section-title">Cap Rate</div>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <mat-form-field>
        <mat-label>Cap Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlCapRate" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlCapRate); track errorKey) {
          <mat-error>
            @if (formControlCapRate.touched && formControlCapRate.hasError(errorKey)) {
              {{errorMessage(formControlCapRate, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="mat-h3 rate-card-section-title">12T Trucks</div>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <mat-form-field>
        <mat-label>Truck (2T) Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlTruck12T" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlTruck12T); track errorKey) {
          <mat-error>
            @if (formControlTruck12T.touched && formControlTruck12T.hasError(errorKey)) {
              {{errorMessage(formControlTruck12T, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="mat-h3 rate-card-section-title">No Asset Backed Rate</div>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <mat-form-field>
        <mat-label>No Asset Backed Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlNoAssetBacked" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlNoAssetBacked); track errorKey) {
          <mat-error>
            @if (formControlNoAssetBacked.touched && formControlNoAssetBacked.hasError(errorKey)) {
              {{errorMessage(formControlNoAssetBacked, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="mat-h3 rate-card-section-title">Transaction Type Rate</div>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <transaction-type-rate [mark]="triggerMark" [formControl]="formControlTransactionTypeRate"></transaction-type-rate>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="mat-h3 rate-card-section-title">Risk Profile</div>
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Adverse on file</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlAdverseOnFile" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlAdverseOnFile); track errorKey) {
          <mat-error>
            @if (formControlAdverseOnFile.touched && formControlAdverseOnFile.hasError(errorKey)) {
              {{errorMessage(formControlAdverseOnFile, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Low director-score (&lt; 550)</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlLowDirectorScoreUplift" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlLowDirectorScoreUplift); track errorKey) {
          <mat-error>
            @if (formControlLowDirectorScoreUplift.touched && formControlLowDirectorScoreUplift.hasError(errorKey)) {
              {{errorMessage(formControlLowDirectorScoreUplift, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Premium Discount</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlPremiumDiscount" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlPremiumDiscount); track errorKey) {
          <mat-error>
            @if (formControlPremiumDiscount.touched && formControlPremiumDiscount.hasError(errorKey)) {
              {{errorMessage(formControlPremiumDiscount, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Not asset backed low deposit</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlLowDepositUplift" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlLowDepositUplift); track errorKey) {
          <mat-error>
            @if (formControlLowDepositUplift.touched && formControlLowDepositUplift.hasError(errorKey)) {
              {{errorMessage(formControlLowDepositUplift, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate [mark]="triggerMark" title="ABN Age (months)" [formControl]="formControlGstAge"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate [mark]="triggerMark" title="Doc Fee" [type]="'currency'" [formControl]="formControlDocFee"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate [mark]="triggerMark" title="Brokerage" [formControl]="formControlBrokerage"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate formControlErrorsIgnore title="Loan amount" [formControl]="formControlLoanAmount"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate [mark]="triggerMark" formControlErrorsIgnore title="Loan Terms" [formControl]="formControlLoanTerms"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <asset-category-rate [mark]="triggerMark" title="Asset Category" [formControl]="formControlAssetCategpry"></asset-category-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <asset-type-rate [mark]="triggerMark" title="Asset Type" [formControl]="formControlAssetType"></asset-type-rate>

</div>
